import { FC, memo } from 'react'
import { useRouter } from 'next/router'
import Link from 'next/link'

import { cutHashFromURL } from 'utils/getURLData'
import { popupName } from 'constants/auth/auth-data'

import styles from './no_access_banner.module.scss'

interface INoAcceessBanner {
  txt?: string
}

const NoAcceessBanner: FC<INoAcceessBanner> = ({ txt = 'Доступ ограничен 😔' }) => {
  const router = useRouter()
  const path = cutHashFromURL(router.asPath)
  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>{txt}</div>
      <div className={styles.subtitle}>
        Чтобы посмотреть клинический случай, пожалуйста,{' '}
        <Link href={`${path}#${popupName.registration}`}>
          <span>войдите</span>
        </Link>
         на Medpoint
      </div>
    </div>
  )
}

export default memo(NoAcceessBanner)
